import * as React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'react-bootstrap';
import { connect } from 'react-redux';
import preload from 'redux-preload';

import Team from './team';
import { fetchOrganizations } from './actions';

@connect(({ organizations: { direct, supporter } }) => ({ direct, supporter }))
@preload(fetchOrganizations)
export default class TeamSection extends React.Component {
  static propTypes = {
    direct: PropTypes.arrayOf(PropTypes.object).isRequired,
    supporter: PropTypes.arrayOf(PropTypes.object).isRequired,
  };

  render() {
    const { direct, supporter } = this.props;

    return (
      <Grid>
        <div style={styles.row}>
          { direct.map(organization => <Team {...organization} key={`organization-${organization.id}`} />) }
        </div>
        <h2>Podporují nás</h2>
        <div style={styles.row}>
          { supporter.map(organization => <Team {...organization} key={`organization-${organization.id}`} />) }
        </div>
      </Grid>
    );
  }
}

const styles = {
  row: {
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'space-around'
  }
};



// WEBPACK FOOTER //
// ./src/browser/Feature/components/team_section/index.jsx